import { Injectable } from '@angular/core';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { Observable } from 'rxjs';

import {
  MapAppBottomSheetContainer,
  SelectAddressBottomSheetContainer,
} from '../../containers';
import { MapAppsData, SelectAddressData } from '@sc/data-access-models';

@Injectable({
  providedIn: 'root',
})
export class BottomSheetService {
  constructor(private readonly matBottomSheet: MatBottomSheet) {}

  show<I, O>(component, params: I): Observable<O> {
    return this.matBottomSheet
      .open<typeof component, I, O>(component, {
        data: params,
      })
      .afterDismissed();
  }

  showSelectAddress(data: SelectAddressData) {
    return this.show<SelectAddressData, SelectAddressData>(
      SelectAddressBottomSheetContainer,
      data
    );
  }

  showMapApps(data: MapAppsData): Observable<void> {
    return this.show<MapAppsData, void>(MapAppBottomSheetContainer, data);
  }
}
